<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

      <div class="p-grid">
        <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
        </div>
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'number'" [control]="form.get('number')" [type]="'input'" [label]="t('common.labels.customer_number')"></app-form-control>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <h2>{{ t('common.labels.address') }}</h2>
          <app-form-control [cid]="'company'" [control]="form.get('company')" [type]="'input'" [label]="t('common.labels.company')"></app-form-control>
          <app-form-control [cid]="'street'" [control]="form.get('street')" [type]="'input'" [label]="t('common.labels.street')"></app-form-control>
          <div class="p-grid">
            <div class="p-col-2">
              <app-form-control [cid]="'zip'" [control]="form.get('zip')" [type]="'input'" [label]="t('common.labels.zip')"></app-form-control>
            </div>
            <div class="p-col-6">
              <app-form-control [cid]="'city'" [control]="form.get('city')" [type]="'input'" [label]="t('common.labels.city')"></app-form-control>
            </div>
            <div class="p-col-4">
              <app-form-control [cid]="'country'" [control]="form.get('country')" [type]="'select'" [options]="countries" optionLabel="country_name" [dataKey]="'country_code'" [filter]="true" [showClear]="true" [label]="t('common.labels.country')"></app-form-control>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <h2>{{ t('common.labels.contact') }}</h2>
          <app-form-control [cid]="'phone'" [control]="form.get('phone')" [type]="'input'" [label]="t('common.labels.phone')"></app-form-control>
          <app-form-control [cid]="'email'" [control]="form.get('email')" [type]="'input'" [label]="t('common.labels.email')"></app-form-control>
          <app-form-control [cid]="'web'" [control]="form.get('web')" [type]="'input'" [label]="t('common.labels.web_address')"></app-form-control>
        </div>
      </div>

      <h2>{{ t('common.labels.additional_informations') }}</h2>
      <app-form-control [cid]="'informations'" [control]="form.get('informations')" [type]="'textarea'" [label]="t('common.labels.additional_informations')"></app-form-control>

  </form>
</ng-container>
